export default __webpack_public_path__ + "static/media/problema-05.597f3ca9.webp";